import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)

// SW — offline shell (ústava 96.10, Mirko 2026-07-12): mview sa otvorí aj bez signálu
if ('serviceWorker' in navigator) { navigator.serviceWorker.register('/v2/sw.js').catch(() => {}) }
